import { Content } from '../../types';

export const bangkokContent: Content = {
  title: 'בנגקוק - העיר והאגדה!',
  imageUrl: '/images/thailand/bangkok/bangkok-wide.jpg',
  introduction:
    'כל מה שצריך לדעת על לינה, תחבורה ואטרקציות בעיר הבירה של תאילנד – מדריך מקיף לשנת 2025',
  sections: [
    {
      title: 'היכרות עם בנגקוק – עיר ללא הפסקה',
      type: 'sub-headers',
      content: [
        {
          subtitle: '',
          text: 'בנגקוק (Bangkok), הינה עיר הבירה והמרכז הפוליטי, התרבותי, הכלכלי והתיירותי של תאילנד. מטרופולין ענק, שוקק חיים וצבעוני, המציע מגוון חוויות בלתי נגמר – מקדשים, ארמונות, מוזיאונים, פסטיבלים ומרכזי קניות, המשלבים שווקים מסורתיים לצד קניונים מודרניים, מסורת וקדמה, עבר והווה, וכל זאת בתוך עיר תוססת ודינמית.',
        },
        {
          subtitle: '',
          text: "בנגקוק הינה אחת הערים הגדולות באסיה ומבין יעדי התיירות הפופולריים בעולם. העיר ממוקמת משני צידי נהר הצ'או פראייה, בסמוך למפרץ תאילנד. בעיר מתגוררים מעל 10 מיליון תושבים, ובמטרופולין כולו כ - 14 מיליון. היא נוסדה כבירתה החדשה של תאילנד בשנת 1782 על ידי המלך ראמה הראשון ומאז חוותה תהפוכות רבות, בעיקר בתחום הפוליטי, שהשפיעו על כלל היבטי החיים במדינה",
        },
        {
          subtitle: '',
          text: 'ברחבי העיר ניתן לחוות את השילוב הייחודי בין התרבות התאילנדית המסורתית לבין הקדמה והמודרניות המתפתחת ללא הרף. מצד אחד – מקדשים מרהיבים, ארמונות מפוארים ושווקים אותנטיים המציעים הצצה לאורח החיים המסורתי של תושבי העיר. מצד שני – מגדלי מגורים ועסקים המתנשאים לגבהים אדירים, מרכזי קניות עצומים ומרכזי בילוי שאין להם תחרות, הממחישים את התפתחותה של העיר לכדי מטרופולין גלובלי מוביל.',
        },
        {
          subtitle: '',
          text: 'הניגודים הללו באים לידי ביטוי גם באורח החיים של תושביה. ניתן למצוא נזירים בגלימות כתומות פוסעים בשקט בין גורדי השחקים, לצד צעירים מתלבשים בבגדים אופנתיים הנוהרים למועדונים ולמסעדות יוקרה. באותו הרחוב ניתן לראות דוכני אוכל רחוב המציעים מאכלים מסורתיים לצד מסעדות מפוארות עם מטבח עילי. בעוד שבשעות הבוקר תושבי העיר עוצרים ומשתחווים בפני פסלים בודהיסטיים ומדליקים קטורת, בערבים אותם רחובות הופכים לזירה תוססת של חיי לילה ושווקים מוארים באורות צבעוניים.',
        },
      ],
    },
    {
      title: 'מזג אוויר בבנגקוק – מתי כדאי לבקר?',
      description:
        ':בנגקוק מאופיינת באקלים טרופי לאורך כל השנה, אך יש עונות שכדאי לקחת בחשבון:',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'העונה היבשה (נובמבר–פברואר)',
          text: 'אידיאלית לטיולים, מזג אוויר נעים ויבש.',
        },
        {
          subtitle: 'העונה החמה (מרץ–מאי)',
          text: 'טמפרטורות גבוהות, מתאימה לאוהבי חום.',
        },
        {
          subtitle: 'העונה הרטובה (יוני–אוקטובר)',
          text: 'גשמים בעיקר בשעות אחר הצהריים, מחירים נמוכים יותר.',
        },
      ],
    },
    {
      title: 'אזורים מומלצים ללינה בבנגקוק',
      type: 'sub-headers',
      description:
        'בנגקוק מציעה מגוון רחב של מקומות לינה – מאכסניות בתקציב נמוך ועד למלונות פאר יוקרתיים המשקיפים על הנהר או ממוקמים בלב המרכזים הקוסמופוליטיים של העיר. להלן סקירה אודות אזורי הלינה העיקריים המומלצים לתיירים:',
      content: [
        {
          subtitle: 'אזור הקואסאן Khao San Road',
          text: `לב האזור התרמילאי של העיר. רחוב הקואסאן והסביבה מהווים מוקד מרכזי לתרמילאים מכל העולם. האזור שוקק חיים עם ברים, פאבים, מועדונים, מסעדות, מסאג'ים, שווקים ועוד וניתן למצוא באזור, בכל מקום, את כלל השירותים הנדרשים עבור תיירים. אידיאלי למחפשי אווירה צעירה, מחירים נוחים ומפגש עם מטיילים ממקומות שונים בעולם. באזור זה (רחוב Phra Artit) ממוקם בית חב"ד למטיילים ולפיכך, האזור אידיאלי מאוד עבור התיירים המבקשים לשהות באזור של בית חב"ד.`,
        },
        {
          subtitle: 'סוקומוויט Sukhumvit',
          text: "שדרה מרכזית, ארוכה (ממשיכה עד פטאיה!) ומלאת חיים, הנחשבת לאחת מהמובילות בעיר. תמצאו כאן מלונות יוקרה, דירות נופש, מסעדות מכל הסוגים, חיי לילה סוערים, מסאג'ים ואף קניונים. תחנות BTS פזורות לאורכה ומקשרות בקלות בינה לכל חלקי העיר. אזור מעולה למחפשים חוויית לינה עירונית, מודרנית, קרבה לקניונים ונוחה לתנועה.",
        },
        {
          subtitle: 'אסוק Asok',
          text: "ממוקם בצומת ובו קווי התחבורה העיקריים BTS ו-MRT ובכך מאפשר מעבר מהיר ויעיל לאזורים רבים בעיר. זהו אחד האזורים המרכזיים, הקרובים לקניונים (טרמינל 21), עסקים, שגרירות ישראל, פארק בנצ'טיקי ופארק לומפיני, מסעדות וחיי לילה. מתאים מאוד למטיילים הרוצים לשלב בין תיירות, קניות, אזורים ירוקים ונוחות תחבורתית.",
        },
        {
          subtitle: 'סילום Silom',
          text: "מרכז העסקים של העיר, אך גם אזור עשיר בתרבות וחיי לילה. כאן תמצאו את פארק לומפיני ופארק בנצ'טיקי, את שוק הלילה פטפונג ומסעדות מצוינות. מתאים לאנשי עסקים ולתיירים המחפשים שילוב בין עבודה להנאה.",
        },
        {
          subtitle: 'סיאם Siam',
          text: 'מרכז הקניות של בנגקוק, אזור מצוין למשפחות ולאוהבי שופינג. כאן תמצאו את Central World Siam Paragon, MBK, Siam Discovery, ועוד. בנוסף, תחבורה קלה בזכות BTS Siam Interchange. אידיאלי למחפשים גישה מהירה לכל מקום וקרבה לאטרקציות מודרניות.',
        },
        {
          subtitle: "נהר הצ'או פראייה Chao Phraya River",
          text: 'אזור יוקרתי אך רגוע ומרגיע יותר, על שפת הנהר. בתי מלון מפוארים עם נוף מרהיב, גישה לסירות, קרבה לארמון המלך ולמקדשים המרכזיים. מצוין לזוגות בירח דבש ולאלו שמחפשים שקט לצד נוחות.',
        },
        {
          subtitle: 'פראטונם (Pratunam)',
          text: 'קרוב לאזור  סיאם ומושלם למעוניינים בשופינג בתקציב נוח – שווקים סיטונאיים, קניון פלטינום, ואוכל רחוב מעולה. המחירים לרוב נוחים ולא יקרים, והאווירה תוססת.',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית בבנגקוק',
      type: 'sub-headers',
      description:
        'מערכת התחבורה הציבורית בעיר נוחה ומתקדמת ומהווה את אחד היתרונות הגדולים של העיר – זולה, נוחה ויעילה:',
      sectionLink: {
        url: '/international/thailand/article/bangkok-transportation',
        text: 'למדריך המלא על התחבורה הציבורית בבנגקוק',
      },
      content: [
        {
          subtitle: 'BTS – Sky Train',
          text: 'רכבת עילית מודרנית ומהירה. עוברת דרך אזורי המפתח של העיר כמו סיאם, סוקומוויט, סילום ועוד. אידיאלי לשעות העומס.',
        },
        {
          subtitle: 'MRT',
          text: "משלימה את ה-BTS ומגיעה גם לאזורים המכוסים על ידי הרכבת העילית. מעולה עבור הנוסעים לשוק צ'אטוצ'אק, ל-צ'יינה טאון ועוד.",
        },
        {
          subtitle: 'סירות הנהר (Chao Phraya Express)',
          text: "תחבורה זולה, נעימה ומיוחדת לאורך נהר הצ'או פראייה. נוחה מאוד למעוניינים לבקר באטרקציות ההיסטוריות כמו ארמון המלך, וואט פו, וואט ארון ועוד. יש גם סירות קו בצבעים שונים המציעות תחנות עצירה שונות לכל אורך הנהר.",
        },
        {
          subtitle: 'סירות תעלה Khlong Boats',
          text: 'תחבורה זולה, מהירה ומאוד יעילה. מהווה דרך ייחודית ונוסטלגית לחצות את העיר ומאפשרת חיבור מהיר בין מרכז העיר (פראטונאם – תחנה ראשית) לבין האזורים אשר ממזרח (Asok) וממערב (Pan Fa Pier). גם אם לא הכי נוחות – תמיד חוסכות פקקים!',
        },
        {
          subtitle: 'מוניות',
          text: 'זמינות מאוד, יש לדרוש הפעלת מונה (או סיכום מחיר מראש). נסיעה עם אפליקציות Bolt ו – Grab, מומלצת ונוחה.',
        },
        {
          subtitle: 'מוניות אופנוע',
          text: 'זמינות מאוד, זולות ומהירות, יש להקפיד להזמין  באמצעות Bolt או Grab, מתאים מאוד עבור מטיילים יחידים.',
        },
        {
          subtitle: 'טוקטוקים',
          text: 'חוויה מקומית צבעונית, לא זולה ולכן, חשוב לסכם מחיר מראש.',
        },
        {
          subtitle: 'אוטובוסים ציבוריים',
          text: 'האופציה הכי זולה, אך פחות מומלצת לתיירים, עקב מורכבות הקווים והעומס.',
        },
      ],
    },
    {
      title: 'Sky Train',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok/bangkok-article-3.jpg',
    },
    {
      title: 'דרכי הגעה לבנגקוק ונמלי תעופה בעיר',
      type: 'sub-headers',
      description:
        'בנגקוק מהווה את שער הכניסה המרכזי לתאילנד עבור מרבית המטיילים, עם שני נמלי תעופה בינלאומיים חשובים:',
      content: [
        {
          subtitle: 'נמל התעופה הבינלאומי Suvarnabhumi (BKK)',
          text: 'זהו הנמל הראשי והמודרני של בנגקוק ואחד העמוסים בעולם, הממוקם כ-30 ק"מ מזרחית לעיר. רוב הטיסות הבינלאומיות מגיעות ונוחתות כאן, כולל טיסות ישירות מישראל (אל על). מהנמל ניתן להגיע לעיר בקלות דרך:<br>✓ <strong>רכבת מהירה (Airport Rail Link)</strong> – חיבור מהיר ונוח לאזור מרכז העיר (תחנות Makkasan ו-Phaya Thai).<br>✓ <strong>מוניות</strong> – זמינות בשפע, יש לוודא שימוש במונה ו/או מחיר סגור מראש.<br>✓ <strong>שאטלים פרטיים</strong> או רכבים מוזמנים דרך אפליקציות כמו Grab.<br>✓ <strong>אוטובוסים ציבוריים</strong> (בעלות זולה) המבצעים קווים קבועים למרכז העיר ולאזור הקאוסאן.',
        },
        {
          subtitle: 'נמל התעופה Don Mueang (DMK)',
          text: 'הנמל הוותיק יותר, משמש כיום בעיקר טיסות פנים וטיסות לואו קוסט (חברות כמו AirAsia, Nok Air ו-Lion Air), ממוקם כ-24 ק"מ צפונית למרכז העיר. אפשרויות התחבורה ממנו כוללות:<br>✓ <strong>מוניות</strong> (עם מונה בלבד)<br>✓ <strong>אוטובוסים ציבוריים</strong> בעלות זולה<br>✓ <strong>רכבות</strong> (רכבת פרברית) – מתאימה בעיקר למטיילים עם זמן פנוי וללא ציוד כבד.',
        },
        {
          subtitle: 'מעבר בין שני הנמלים',
          text: 'ניתן לעבור בין שני נמלי תעופה אלו בעזרת שאטלים חינמיים (בהצגת כרטיס טיסת המשך), או מונית (הנסיעה אורכת כשעה–שעה וחצי, תלוי בעומס התנועה).',
        },
        {
          subtitle: 'הגעה לבנגקוק מערים אחרות בתאילנד',
          text: 'ניתן להגיע לבנגקוק ובכלל זה, לנמל התעופה Suvarnabhumi מערים אחרות וממחוזות אחרים במדינה, הן באמצעות טיסות פנים המבוצעות ע"י מגוון רחב של חברות תעופה תאילנדיות והן באמצעות שירותי אוטובוסים ורכבות.',
        },
      ],
    },
    {
      title: 'אטרקציות מרכזיות בבנגקוק',
      type: 'sub-headers',
      description: 'מה תוכלו לעשות במסגרת שהות קצרה בבנגקוק?',
      content: [
        {
          subtitle: 'סיור רגלי במרכז ההיסטורי',
          text: "לשוהים בעיר לזמן קצר ומעוניינים להכיר את פניה ההיסטוריים, נמליץ לצאת לסיור רגלי שיתחיל בארמון המלך המרשים - לב ההיסטוריה והתרבות התאילנדית, להמשיך למקדש וואט פו (הבודהה השוכב) - מקדש אייקוני ומרשים מבחינת אדריכלות, ממנו אל שוק הפרחים הצבעוני ולבסוף אל גשר הזיכרון (Memorial Bridge), לקראת השקיעה. מהגשר נשקף מראה פנורמי עוצר נשימה של קו הרקיע של העיר המשתלב עם נהר הצ'או פראייה. לסיום ובשעות הלילה, מומלץ לבקר בשוק האוכל הלילי של צ'יינה טאון – חוויה קולינרית עשירה בצבעים, ריחות וטעמים ייחודיים.",
        },
      ],
    },
    {
      title: 'אטרקציות נוספות בעיר ובסביבתה – מה לא לפספס',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'נקודות תצפית',
          text: '✓ <strong>Mahanakhon Skywalk</strong> - אחת מנקודות התצפית הגבוהות והמרשימות בבנגקוק, הממוקמת בקומה ה-78 של מגדל King Power Mahanakhon. מכאן נשקף נוף פנורמי של העיר כולה, כולל חוויה מרגשת של הליכה על רצפת זכוכית בגובה עוצר נשימה (מומלץ לקראת שקיעה).<br />✓ <strong>Baiyoke Sky Tower</strong> - המגדל הגבוה ביותר בתאילנד (עד לאחרונה), מציע תצפית 360 מעלות בקומות העליונות. תוכלו ליהנות מארוחת ערב במסעדה מסתובבת ולצפות בנופי העיר בשקיעה או בלילה – חוויה רומנטית ומרשימה (מומלץ לקראת שקיעה).<br />✓ <strong>Sky Bar Lebua</strong> - חוויה לילית עם נוף עוצר נשימה.',
        },
      ],
    },
    {
      title: 'פארקים, פארקי שעשועים ואטרקציות למשפחות',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Lumpini Park',
          text: '"ריאה ירוקה בלב בנגקוק". פארק מרכזי ופופולרי בלב בנגקוק, מושלם לטיול רגוע, ריצה או שייט באגם עם סירות פדלים. המקום מציע אווירה ירוקה ושלווה, במיוחד בשעות הבוקר המוקדמות.',
        },
        {
          subtitle: 'Benchakiti Park',
          text: '"פנינה ירוקה בלב בנגקוק". הפארק העירוני הגדול בבנגקוק, עם אגם, שבילים ירוקים, גשרים ונוף פתוח, המציעים שקט ושלווה בלב העיר.',
        },
        {
          subtitle: 'Dream World',
          text: 'פארק המזכיר את דיסני, עם אזורי נושא כמו "ארץ הפנטזיה" ו"עולם ההרפתקאות". תמצאו כאן מתקנים לקטנים וגדולים, מופעים, אזור שלג מלאכותי (Snow Town) ועוד. חוויה מהנה למשפחות עם ילדים בגילאי 4–12.',
        },
        {
          subtitle: 'Siam Amazing Park',
          text: 'פארק שעשועים ומים גדול במיוחד, עם רכבות הרים, מתקנים לילדים ובריכות עם מגלשות מים. מתאים לכל המשפחה, כולל אזור מיוחד לקטנטנים. מצויין עבור בילוי של יום שלם, במיוחד בימים חמים.',
        },
        {
          subtitle: 'Safari World',
          text: 'פארק ספארי המשלב ספארי ברכב (בדומה לאפריקה) ופארק ימי עם מופעים של דולפינים, אריות ים וציפורים. חווייה נהדרת לילדים – אך יש לקחת בחשבון את המרחק מהעיר (כ-45 דקות נסיעה).',
        },
        {
          subtitle: 'SEA LIFE – Bangkok Ocean World',
          text: 'אקווריום תת-קרקעי עצום ואחד הגדולים באסיה, ממוקם בקומה התחתונה של קניון Siam Paragon. כולל מנהרות שקופות, כרישים, פינגווינים, מדוזות צבעוניות ועוד – חוויה מרתקת גם לילדים וגם למבוגרים, בלב העיר הסואנת.',
        },
        {
          subtitle: 'Madame Tussauds Bangkok',
          text: 'מוזיאון השעווה המפורסם, חוויה מהנה למשפחות בלב בנגקוק, בקניון Siam Discovery. כאן תמצאו דמויות של כוכבי קולנוע, מנהיגים היסטוריים, מוזיקאים ואייקונים בינלאומיים – חוויה אינטראקטיבית נהדרת למשפחות ולחובבי סלפי.',
        },
      ],
    },
    {
      title: 'מוזיאונים בבנגקוק – תרבות, אומנות והיסטוריה מרתקת',
      description:
        'בנגקוק מציע מגוון מוזיאונים המספקים הצצה להיסטוריה, לאמנות ולתרבות התאילנדית.',
      type: 'sub-headers',
      content: [
        {
          subtitle: "מוזיאון ג'ים תומפסון",
          text: "אחד המוזיאונים הייחודיים בעיר הממוקם בבית תאילנדי מקומי מוקף גן ירוק בלב העיר. המוזיאון היה ביתו של ג'ים תומפסון – אמריקאי שפעל להחייאת תעשיית המשי התאילנדית ונעלם באופן מסתורי בשנת 1967. במתחם תמצאו פריטי אמנות אסייתית עתיקה, ריהוט בסיסי וארכיטקטורה תאילנדית קלאסית. שווה לעצור גם בבית הקפה שבגן – פינה שקטה ונעימה בלב העיר, מושלמת למנוחה קלה אחרי הסיור. בנוסף, סמוך למתחם נמצאת חנות משי איכותית עם פריטים בעבודת יד, למי שמעוניין במזכרת מיוחדת ומקומית באמת.",
        },
        {
          subtitle: 'מוזיאון בנגקוק לאמנות עכשווית (MOCA)',
          text: 'מוזיאון מרהיב המציג יצירות מודרניות ועכשוויות של אמנים תאילנדים בולטים. הבניין מרשים מבחוץ לא פחות מהתערוכות שבתוכו ומהווה מקום מושלם לאוהבי אמנות ולמעוניינים לטעום מהתרבות התאילנדית העכשווית.',
        },
        {
          subtitle: 'מוזיאון ארמון סואן פאקרד (Suan Pakkad Palace)',
          text: 'מתחם שקט ופסטורלי הכולל מספר מבנים בסגנון תאילנדי מסורתי, ששימשו בעבר את משפחת המלוכה. המוזיאון מציג אוספים של אמנות, עתיקות, כלי נגינה מסורתיים ועוד – חוויה מיוחדת בלב העיר הסואנת.',
        },
        {
          subtitle: 'Museum of Siam',
          text: 'מוזיאון חווייתי, מודרני ואינטראקטיבי המיועד לכל המשפחה, הסוקר את התרבות, ההיסטוריה והזהות התאית. מתאים במיוחד למעוניינים להעמיק ולהבין את השאלה "מה זה בעצם להיות תאי?" – בדרך מקורית ומהנה.',
        },
      ],
    },
    {
      title: 'שווקים וקניונים בבנגקוק',
      description: `בבנגקוק קיים מגוון רחב של שווקים, שווקי יום, שווקי לילה, שווקי סופ"ש, שווקים באירועים שונים ועוד. אל תפספסו את שוק סוף השבוע צ'אטוצ'אק Chatuchak Weekend Market  – השוק הגדול באסיה ומהווה חוויה אותנטית לאוהבים שופינג ותרבות מקומית גם יחד.`,
      type: 'sub-headers',
      content: [
        {
          subtitle: 'קניונים מרכזיים',
          text: 'בבנגקוק גם מגוון ענק של קניונים, החל מ - Central World / Siam Paragon / IconSiam – קניונים מהגדולים והמפוארים שבעיר, כפרט ובתאילנד כולה ככלל, עם חנויות ממותגות, מתחמי אוכל עשירים, ואטרקציות למשפחות וילדים.',
          link: {
            url: '/international/thailand/article/bangkok-malls',
            text: 'למדריך המלא על הקניונים המרכזיים בבנגקוק',
          },
        },
        {
          subtitle: 'טיפ לקניות ביום אחד',
          text: 'יש לכם יום אחד בלבד לקניות? המלצתנו הינה להתמקד ב"משולש" הכולל את Central World, Platinum Mall ו–Big C Supercenter, השילוה המנצח עבור יום אחד!',
        },
      ],
    },
    {
      title: 'דוכן אננס',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok/bangkok-article-1.jpg',
    },
    {
      title: 'חוויות קולינריות בבנגקוק – חגיגה של טעמים',
      description:
        "בנגקוק הינה גן עדן לחובבי אוכל – משווקי רחוב שוקקי חיים ועד למסעדות יוקרה עטורות כוכבי מישלן. העיר מציעה מגוון עצום של טעמים – מתבשילים תאיים חריפים, דרך מנות אסייתיות מרחבי היבשת ועד מנת פיוז'ן מודרנית. בין המנות הפופולריות שתמצאו כמעט בכל פינה: פאד תאי, מרק טום יאם, קאו סוי (מרק קארי מהצפון), וסום טאם – סלט פפאיה ירוקה חריף ומרענן.",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'שווקי אוכל מומלצים',
          text: "שווקי הרחוב של בנגקוק הינם מקום מצוין להתחיל בו את ההרפתקה הקולינרית – בדגש על שוק רחוב Yaowarat בצ'יינה טאון (בלילה), שוק Ratchada Night Market, ושוק או טור קור הסמוך לשוק Chatuchak. כל אלו מציעים חוויית טעמים אותנטית במחירים נוחים.",
        },
      ],
    },
    {
      title: 'חיי לילה בבנגקוק – עיר שלא הולכת לישון',
      description:
        'כשהשמש שוקעת, משנה בנגקוק את פניה – ממטרופולין שוקק למוקד בילויים תוסס. חיי הלילה בעיר מגוונים ומפתיעים: החל מברים על גג (Rooftop Bars) עם נופים עוצרי נשימה של קו הרקיע של העיר, דרך פאבים ומועדונים בקאו סאן רואד וסוקומוויט ועד מסיבות אלקטרוניות עד אור הבוקר.',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'ברים על גג מומלצים',
          text: '✓ <strong>Sky Bar at Lebua</strong> – אחד מהברים הגבוהים והמרשימים ביותר בעיר.<br />✓ <strong>Tichuca Rooftop Bar</strong> – אווירה צעירה, עיצוב טרופי ונוף מהמם.',
        },
      ],
    },
    {
      title: 'טיולים קולינריים וברים בבנגקוק',
      type: 'sub-headers',
      description: 'טיולים קולינריים מודרכים – לטעום את בנגקוק כמו מקומי',
      content: [
        {
          subtitle: 'חוויות קולינריות מודרכות',
          text: 'אחת הדרכים הטובות ביותר להכיר את בנגקוק, הינה להצטרף לטיול קולינרי מודרך. בטיולים, תכירו את מאחורי הקלעים של סצנת האוכל המקומית – דוכנים סמויים, מתכונים אלוהיים וטעמים שלא תמצאו במדריך הרגיל.',
        },
        {
          subtitle: 'סיורים קולינריים מומלצים',
          text: "✓ <strong>Bangkok Food Tours</strong> – סיורים רגליים בשווקים מקומיים.<br />✓ <strong>A Chef's Tour</strong> – טיול קולינרי אינטימי בצ'יינה טאון.<br />✓ <strong>Secret Food Tours</strong> – סיורים עם נגיעה של סיפור היסטורי ותרבותי.",
        },
        {
          subtitle: 'ברים מומלצים בבנגקוק',
          text: "✓ <strong>Vesper</strong> – בר קוקטיילים יוקרתי עם מגע אירופאי, דורג ברשימת 50 הברים הטובים באסיה.<br />✓ <strong>Teens of Thailand</strong> – בר קטן עם התמחות בג'ין, הממוקם בלב ציינה טאון.<br />✓ <strong>Smalls Bar & Live Music</strong> – בר בוהמייני עם מוזיקה חיה, קומה עליונה פתוחה ונוף יפהפה.<br />✓ <strong>Tropic City</strong> – קוקטיילים טרופיים וצבעוניים באווירה חמה ומוזיקת ​​דיסקו עדינה.",
        },
      ],
    },
    {
      title: 'טיפים חשובים למטיילים בבנגקוק',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'עונות וזמני ביקור',
          text: 'נובמבר – מרץ הינה התקופה הנוחה ביותר אך בבנגקוק כמו ביתר האזורים בתאילנד, ניתן לטייל בכל זמן!',
        },
        {
          subtitle: 'התארגנות והזמנות',
          text: 'הזמינו לינה מראש (עם אופציית ביטול), דגש על עונות השיא (נובמבר–מרץ).',
        },
        {
          subtitle: 'המלצות כספיות',
          text: 'הביאו דולרים או אירו (שטרות חדשים) – שערי החליפין לעיתים טובים יותר מאשר משיכת כסף בכספומט.',
        },
        {
          subtitle: 'מזג האוויר והתמודדות עמו',
          text: 'בנגקוק חמה ולחה - הקפידו על שתייה והפסקות במקומות ממוזגים.',
        },
        {
          subtitle: 'בטיחות בדרכים',
          text: 'שימו לב לרמזורים ולכלי רכב – אין זכות קדימה להולכי רגל.',
        },
        {
          subtitle: 'ביטחון אישי',
          text: 'שמרו על חפצים אישיים בשווקים צפופים.',
        },
        {
          subtitle: 'לבוש במקדשים',
          text: 'הקפידו על לבוש צנוע – כתפיים וברכיים מכוסות.',
        },
        {
          subtitle: 'המלצות תחבורה',
          text: 'השתמשו באפליקציות Bolt ו-Grab לנסיעות בטוחות ונוחות – הן גם חוסכות התמקחויות מיותרות עם נהגי מוניות וטוקטוקים.',
        },
        {
          subtitle: 'תקשורת אינטרנט',
          text: 'מומלץ לרכוש סים מקומי עם חבילת גלישה בשדה התעופה – מאוד זול ונוח.',
        },
        {
          subtitle: 'טיפים לביקור במוזיאונים',
          text: '✓ <strong>MOCA</strong> – מומלץ בבוקר כשפחות עמוס, אידיאלי ליום גשום.<br />✓ <strong>Suan Pakkad Palace</strong> – חוויה של תרבות והיסטוריה בלב העיר.<br />✓ <strong>Museum of Siam</strong> – מתאים במיוחד למשפחות, סמוך למקדשים כך שניתן לשלב ביקור.<br />✓ <strong>Jim Thompson House</strong> – הצטרפו לסיור המודרך כדי ליהנות מהסיפור ההיסטורי של תעשיית המשי התאילנדי ומהאווירה המיוחדת בבית המסורתי והגן המטופח.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'בנגקוק הינה עיר של ניגודים – ישן מול חדש, שקט מול רעש, מסורת מול מודרניות – וכל זה במקום אחד תוסס ומלא חיים. העיר מציעה לכל מבקר חוויה חד פעמית ומסע בין תרבות, היסטוריה, קדמה וחדשנות. כל פינה בעיר מספרת סיפור אחר, והקסם שבה טמון דווקא בשילוב הייחודי של כל הניגודים הללו לכדי עיר אחת בלתי נשכחת.',
    },
  ],
};
